import { BorderGridContainer, GridBox, HeroBanner, PortableText } from '@ahmdigital/ui';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import {
  ContentWrapper,
  HeaderWrapper,
  OverflowWrapper,
  PlaneVideoWrapper,
  SubtitleWrapper,
  TitleSection,
  TitleWrapper,
} from './styles';
import { ImageType } from '../../../../types/image';
import { PortableTextType } from '../../../../types/sanityInternal';
import { SANITY_MEDIA_FILES } from '../../../../ahm-constants/ui';
import { SectionOfferStrip } from '../../../insurance/types';
import { TravelWidgetProvider } from './components/widget/hooks/travel-widget-context';
import Awards from './components/awards';
import device from '../../../../utils/device';
import TravelWidget from './components/widget';

type Props = {
  title: PortableTextType[];
  offer: SectionOfferStrip;
  image?: ImageType;
  subtitle?: PortableTextType[];
};

const Header = ({ title, offer, image, subtitle }: Props) => {
  const [isWidgetActive, setIsWidgetActive] = useState(false);
  const router = useRouter();
  const { productOptionValue } = router.query;

  const FooterContent = (
    <>
      <TravelWidgetProvider>
        <TravelWidget
          isWidgetActive={isWidgetActive}
          offer={offer}
          setIsWidgetActive={setIsWidgetActive}
          isDestinationPage={!!productOptionValue}
        />
      </TravelWidgetProvider>
      <Awards />
    </>
  );
  if (productOptionValue) {
    return (
      <HeroBanner
        title={title}
        subtitle={subtitle}
        image={device.isLargeTabletOrMobile() ? null : image}
        footer={FooterContent}
      />
    );
  }
  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="0">
        <HeaderWrapper>
          <OverflowWrapper>
            <PlaneVideoWrapper>
              <video autoPlay muted playsInline height="500px">
                <source src={SANITY_MEDIA_FILES.PLANE_VIDEO} type="video/mp4" />
              </video>
            </PlaneVideoWrapper>
          </OverflowWrapper>
          <ContentWrapper>
            <TitleSection>
              <TitleWrapper>
                <PortableText source={title} />
                <SubtitleWrapper>
                  <PortableText source={subtitle} />
                </SubtitleWrapper>
              </TitleWrapper>
            </TitleSection>
            {FooterContent}
          </ContentWrapper>
        </HeaderWrapper>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Header;
